import React from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
const pillars = [{
  num: '01',
  title: 'Local Expertise',
  desc: 'Three decades navigating Phoenix neighborhoods, market cycles, and pricing strategy. We know this market block by block.'
}, {
  num: '02',
  title: 'Personal Attention',
  desc: 'You are not a number. We take the time to understand your goals and tailor every step to your specific situation.'
}, {
  num: '03',
  title: 'Trust & Integrity',
  desc: 'Honesty and professionalism are non-negotiable. We earn your business once, and we earn it for life.'
}];
export function WhyChooseSection() {
  return <section className="py-24 md:py-32 bg-sand" data-id="element-328">
      <div className="container mx-auto px-6" data-id="element-329">
        <FadeInUp className="text-center max-w-3xl mx-auto mb-20 md:mb-32" data-id="element-330">
          <SectionEyebrow text="Why Choose Us" data-id="element-331" />
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal mb-6 text-balance" data-id="element-332">
            30 years. Thousands of families. One promise.
          </h2>
          <p className="text-charcoal-text/80 text-lg md:text-xl" data-id="element-333">
            We believe great real estate starts and ends with trust.
          </p>
        </FadeInUp>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 mb-20" data-id="element-334">
          {pillars.map((pillar, index) => <FadeInUp key={pillar.num} delay={index * 0.15} className="relative" data-id="element-335">
              <div className="text-6xl md:text-8xl font-serif text-terracotta/20 absolute -top-8 md:-top-12 left-0 pointer-events-none select-none" data-id="element-336">
                {pillar.num}.
              </div>
              <div className="relative z-10 pt-8" data-id="element-337">
                <h3 className="text-2xl font-serif text-charcoal mb-4" data-id="element-338">
                  {pillar.title}
                </h3>
                <p className="text-charcoal-text/80 leading-relaxed" data-id="element-339">
                  {pillar.desc}
                </p>
              </div>
            </FadeInUp>)}
        </div>

        <FadeInUp delay={0.4} className="text-center" data-id="element-340">
          <a href="#" className="inline-block px-8 py-4 bg-terracotta text-white rounded font-medium hover:bg-terracotta/90 transition-colors shadow-lg" data-id="element-341">
            Schedule a Conversation
          </a>
        </FadeInUp>
      </div>
    </section>;
}